import { IHeaderGroupParams } from "@ag-grid-community/core";
import { Box } from "@chakra-ui/react";
import React from "react";
import { MaybernTableHeaderGroupExpandButton } from "shared/components/table/maybern/MaybernTableHeaderGroupExpandButton";

export const FundFamilyUseAllocationTableHeaderGroupComponent: React.FC<
  IHeaderGroupParams
> = (params) => (
  <Box>
    {params.displayName}
    <MaybernTableHeaderGroupExpandButton {...params} />
  </Box>
);
